/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { materialIconDefaults, MaterialIconProps } from './MaterialIcon.props';

export const MaterialIcon = (props: MaterialIconProps): JSX.Element => {
  const { color, name } = { ...materialIconDefaults, ...props };

  const hex = /^#[0-9A-F]{6}$/i.test(color) ? { background: color } : {};

  return (
    <span aria-hidden className={`material-icons-two-tone material-icon-color-${color}`} style={hex}>
      {name}
    </span>
  );
};
